/** Rejects if `promise` does not settle within `ms`. */
export class OperationTimeoutError extends Error {
  readonly code = 'timeout';

  constructor(label?: string) {
    super(label ? `${label} timed out` : 'Operation timed out');
    this.name = 'OperationTimeoutError';
  }
}

export const FIRESTORE_OP_TIMEOUT_MS = 30_000;

export function withTimeout<T>(
  promise: Promise<T>,
  ms = FIRESTORE_OP_TIMEOUT_MS,
  label?: string
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new OperationTimeoutError(label));
    }, ms);

    promise.then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      (error: unknown) => {
        clearTimeout(timer);
        reject(error);
      }
    );
  });
}
